import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import App from './App';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { queryDomExample } from '@/sub-luca-plugin/utils/class-example';
import { sentryInit } from './utils';
import { qiankunClassExample } from '@/sub-luca-plugin/utils/tools';
import './assets/css/common.scss';
import { initI18n } from '@/sub-luca-plugin/i18n';

let root: ReactDOM.Root;

export async function bootstrap() {}
export async function update() {}
export async function mount(props: any) {
    console.log('micro-app', props);
    if (props.loadMicroApp) qiankunClassExample.setLoadMicroAppFn(props.loadMicroApp);
    if (props.container) queryDomExample.setShadowRoot(props.container);
    // 初始化i18n 默认中文
    initI18n(props.lang || 'zh');
    const container = props.container || document;
    root = ReactDOM.createRoot(container.getElementById('luca-qa-root') as HTMLElement);
    root.render(
        <ConfigProvider locale={props.lang === 'en' ? enUS : zhCN}>
            <App {...props} />
        </ConfigProvider>
    );
}
export async function unmount() {
    root.unmount();
}

if (!window.__POWERED_BY_QIANKUN__) {
    process.env.CROSS_ENV === 'production' && sentryInit();
    mount({});
}
